/* global css */
import React from 'react';
import cx from 'classnames';
import { cssInJS } from '../../utils/styles';
import THEME from '../../shared/theme';

interface Props {
  value: string,
}

const FieldDisplay: React.FC<Props> = ({
  value,
}: Props) => {
  // @ts-ignore
  const style = css(styles.label);

  return (
    <div className={cx(style)}>{value}</div>
  );
};

const styles = cssInJS({
  label: {
    paddingTop: 10,
    paddingLeft: 5,
    marginBottom: 10,
    fontSize: THEME.editFontSize,
    whiteSpace: 'pre-wrap',
  },
});

export default FieldDisplay;
